// import external dependencies
import 'jquery';

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());

// const menuSelector = document.getElementById('menuSelector');
// const menuExit = document.getElementById('menuExit');
// const mobileMenu = document.getElementById('mobile-menu');

// menuSelector.addEventListener('click', function (){
//   mobileMenu.classList.remove('d-none');
// });
//
// menuExit.addEventListener('click', function (){
//   mobileMenu.classList.add('d-none');
// });

$('#mobile-menu').hide();

$('#menuSelector').click(function(){
    $('#mobile-menu').show();
});

$('.fa-times').click(function(){
    $('#mobile-menu').hide();
});



// WEBPACK FOOTER //
// ./scripts/main.js